module.exports = __webpack_public_path__ + "assets/img/zbt_3.f7e20283.png";